import React from 'react';
import { practitionerInfo } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="section-padding about-section">
      <div className="container">
        <div className="about-content-centered">
          <h2 className="hero-medium">À Propos</h2>
          <h3 className="heading-1 about-name">{practitionerInfo.name}</h3>
          <p className="body-small about-title">{practitionerInfo.title}</p>
          
          <p className="body-large about-description">
            {practitionerInfo.description}
          </p>

          <div className="about-values">
            <div className="value-item">
              <h4 className="heading-3">Approche Humaine</h4>
              <p className="body-regular">Chaque patient est unique. J'adapte mes soins à vos besoins spécifiques avec écoute et bienveillance.</p>
            </div>
            <div className="value-item">
              <h4 className="heading-3">Expertise Professionnelle</h4>
              <p className="body-regular">Formation complète en kinésithérapie, Hijama et massage thérapeutique pour des soins de qualité.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;